exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".NavStyle{color:#000}@media(max-width:500px){.NavStyle{color:#fff}}", "", {"version":3,"sources":["/Users/jmac/Downloads/Proj/282021/HT2021/HT2021/hullthread version 2.0/tests/src/components/Drawer/Drawer.css"],"names":[],"mappings":"AAAA,UACA,UAAY,CACX,AAED,wBACI,UACI,UAAY,CACf,CACJ","file":"Drawer.css","sourcesContent":[".NavStyle{\ncolor: black\n}\n\n@media(max-width: 500px){\n    .NavStyle{\n        color: white\n    }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Drawer/Drawer.css
// module id = 1090
// module chunks = 0 1 2 4 5 6 18 19 20 21